// payment-qr-popup.js
import Swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import http from "@/services/AuthService";
import router from '@/router/index';

// ====== ตั้งค่าระยะเวลาหมดอายุของ QR (วินาที) ======
const DURATION_SEC = 600; // 10 นาที

const EXPIRE_ASSUMPTION = 'utc'; // 'utc' หรือ 'bangkok'

// เติม +07:00 ถ้าจำเป็น
function normalizeExpireToIso(expireStr) {
    // เปลี่ยน ' ' เป็น 'T'
    let s = String(expireStr).trim().replace(' ', 'T');

    // มีโซนแล้วหรือยัง?
    const hasZone = /Z$|[+-]\d{2}:\d{2}$/.test(s);

    if (!hasZone) {
        if (EXPIRE_ASSUMPTION === 'bangkok') {
            s += '+07:00';                 // ถือว่าเวลาที่ส่งมาเป็นเวลาประเทศไทย
        } else {
            s += 'Z';                       // ถือว่าเป็น UTC
        }
    }
    return s;
}
// parse เป็น Date ด้วย normalizeExpireToIso
function parseExpire(expireStr) {
    return new Date(normalizeExpireToIso(expireStr));
}

// ==== API สร้าง QR Code ====
async function fetchPaymentQR() {
    const AuthorizeToken = localStorage.getItem('AuthorizeToken');
    return http.get(`AgencyERequest/GenerateQRPaymentBAC`, {
        headers: { Authorization: `Bearer ${AuthorizeToken}` }
    })
        .then((response) => {
            if (response.status === 200) {
                const { amount, reference1: ref1, reference2: ref2, expireDate: expire, qrCode: qr } = response.data;
                const contentType = qr?.ContentType ?? qr?.contentType ?? 'image/png';
                const fileBase64 = qr?.FileData ?? qr?.fileData;
                if (!fileBase64) throw new Error('QR FileData is empty');

                const img = `data:${contentType};base64,${fileBase64}`;
                const serverTimeStr = response.headers?.date || null;

                return {
                    img,
                    ref1,
                    ref2,
                    amount,
                    remainSec: secondsRemain(expire, serverTimeStr) // ใช้ค่าที่ clamp แล้ว (0..600)
                };
            } else {
                Swal.fire({
                    icon: 'error',
                    html: `<label class="fs-4 fw-normal font-family">${response.data.ErrorMessage}</label>`,
                    customClass: {
                        popup: 'swal-wide',
                        confirmButton: 'btn-bla'// pv-btn-primary
                    }
                });
                return null;
            }
        })
        .catch((error) => {
            Swal.fire({
                icon: 'error',
                html: `<label class="fs-4 fw-normal font-family">${error.response?.data?.ErrorMessage || 'เกิดข้อผิดพลาด'}</label>`,
                customClass: {
                    popup: 'swal-wide',
                    confirmButton: 'btn-bla'// pv-btn-primary
                }
            });
            return null;
        });
}

// ==== เช็คสถานะการชำระเงิน ====
async function checkPaymentStatus(ref1, ref2, { isFinal = false } = {}) {
    const AuthorizeToken = localStorage.getItem('AuthorizeToken');

    try {
        const request = {
            reference1: ref1
            , reference2: ref2
        };

        const res = await http.post(`AgencyERequest/CheckPaymentStatusBAC`, request, { headers: { Authorization: `Bearer ${AuthorizeToken}` } });
        return {
            ok: true
            , isSuccess: res?.data?.isSuccess ?? false
            , data_raw: res?.data.paymentStatusData
        };
    } catch (err) {
        console.error(`[CheckPaymentStatusBAC] ${isFinal ? '(final)' : ''}`, err);
        return { ok: false, status: 'ERROR', error: err };
    }
}

// ====== แปลง ExpireDate -> วินาทีที่เหลือ (ชดเชย clock skew + clamp 0..DURATION_SEC) ======
function secondsRemain(expireStr, serverTimeStr) {
    const exp = parseExpire(expireStr);

    let nowClient = Date.now();
    if (serverTimeStr) {
        const serverNow = new Date(serverTimeStr).getTime(); // RFC1123
        nowClient += (serverNow - nowClient); // ชดเชยนาฬิกา
    }

    // ใช้ floor ให้เฟรมแรกเป็น 10:00 หรือ 09:59 ตามจริง ไม่เคยเกิน 10:00
    let diffSec = Math.floor((exp.getTime() - nowClient) / 1000);

    if (diffSec > DURATION_SEC) diffSec = DURATION_SEC; // ไม่ให้เกิน 10 นาที
    if (diffSec < 0) diffSec = 0;

    return diffSec;
}

function fmtMMSS(sec) {
    const m = Math.floor(sec / 60).toString().padStart(2, '0')
    const s = (sec % 60).toString().padStart(2, '0')
    return `${m}:${s}`
}

/**
 * เปิด popup ชำระเงินด้วย QR PromptPay
 */
export async function openPaymentQrPopup() {
    // const first = await fetchPaymentQR(); // ต้องคืน { img, ref1, ref2, remainSec }

    // let remain = first.remainSec || 10;

    let timer = null;
    let checkInterval = null;
    let settled = false; // ป้องกันทำซ้ำ

    const html = `
        <div class="qrpp-wrap font-bla">
        <!-- หัวข้อ -->
        <div class="qrpp-header">
            <div class="qrpp-title">ชำระเงิน</div>
            <div class="qrpp-divider"></div>
            <div class="qrpp-sub">กรุณาชำระเงินก่อน QR Code นี้หมดอายุ</div>
            <div id="countdown" class="qrpp-timer">--:--</div>
        </div>

        <!-- การ์ด QR + สถานะโหลด/หมดอายุ -->
        <div class="qrpp-card">
            <img id="qr-img" src="" alt="QR" class="qrpp-qr"/>

            <!-- โหลด QR -->
            <div id="qr-loading" class="qrpp-overlay qrpp-loading">
            <div class="qrpp-spinner"></div>
            <span>กำลังสร้าง QR...</span>
            </div>

            <!-- หมดอายุ -->
            <div id="qr-overlay" class="qrpp-overlay qrpp-expired" style="display:none">
            <button id="btn-regenerate" class="qrpp-regenerate">
                <svg width="18" height="18" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
                <path d="M11.534 7h1.932a.5.5 0 0 1 .39.812l-2.387 3a.5.5 0 0 1-.78 0l-2.387-3A.5.5 0 0 1 8.534 7h1.932A3.5 3.5 0 1 0 5 10H4a4.5 4.5 0 1 1 7.534-3z"/>
                </svg>
                สร้าง QR Code ใหม่
            </button>
            </div>

            <!-- ขณะตรวจสอบสถานะ -->
            <div id="qr-checking" class="qrpp-overlay" style="display:none">
            <div class="qrpp-spinner lg"></div>
            </div>
        </div>

        <!-- ข้อมูลใต้ QR ให้หน้าตาตามภาพ -->
        <div class="qrpp-info">
            <div class="qrpp-inline">
                <div class="qrpp-label">รายละเอียด:</div>
                <div class="qrpp-row">ค่าขอทำบัตรประจำตัวผ่านเข้าออกอาคารสำนักงาน</div>
            </div>

            <div class="qrpp-inline">
                <div class="qrpp-label">บัญชี:</div>
                <div class="qrpp-row">บริษัท กรุงเทพประกันชีวิต จำกัด (มหาชน)</div>
            </div>

            <!-- โชว์ reference ตามของเดิม -->
             <div class="qrpp-ref" style="display:none;">
                Reference 1: <b id="ref1">-</b> &nbsp;&nbsp;
                Reference 2: <b id="ref2">-</b>
            </div>
        </div>

        <!-- ยอดรวมตัวหนาสีน้ำเงิน -->
        <div class="qrpp-total" id="amountBottom">0 บาท</div>
        </div>
        `;


    await Swal.fire({
        title: '',//ชำระเงิน
        html,
        width: 600,
        showConfirmButton: false,
        showCancelButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        buttonsStyling: false,
        didOpen: async () => {
            const $html = Swal.getHtmlContainer();
            const $img = $html.querySelector('#qr-img');
            const $cd = $html.querySelector('#countdown');
            const $ovl = $html.querySelector('#qr-overlay');
            const $ref1 = $html.querySelector('#ref1');
            const $ref2 = $html.querySelector('#ref2');
            const $loading = $html.querySelector('#qr-loading');
            const $checking = $html.querySelector('#qr-checking');

            // const showOverlay = (show) => $ovl.style.display = show ? 'flex' : 'none';
            const showOverlay = (show) => {
                $ovl.style.display = show ? 'flex' : 'none';
                $img.style.opacity = show ? 0.4 : 1;
            };
            const showChecking = (show) => $checking.style.display = show ? 'flex' : 'none';
            const showLoading = (show) => $loading.style.display = show ? 'flex' : 'none';

            showOverlay(false);
            showChecking(false);
            showLoading(true);

            const elBottom = $html.querySelector('#amountBottom');
            // default
            // elBottom.textContent = (parseFloat(store.state.AgentRenewLicense.DataTrainingCourseRenewal.amount) || 0).toFixed(2);
            elBottom.textContent = (parseFloat(270) || 0).toFixed(2);

            // โหลด QR ทีหลัง
            const first = await fetchPaymentQR();
            if (!first) return;

            $img.src = first.img;
            $ref1.textContent = first.ref1 ?? '-';
            $ref2.textContent = first.ref2 ?? '-';

            let firstRemain = first.remainSec || DURATION_SEC;
            $cd.textContent = fmtMMSS(firstRemain);

            const amount = parseFloat(first.amount) || 0;

            if (elBottom) elBottom.textContent = `${amount.toFixed(2)} บาท`;

            showLoading(false);

            const ref1Val = ($ref1?.textContent || '').trim();
            const ref2Val = ($ref2?.textContent || '').trim();

            const handlePaidOnce = async () => {
                if (settled) return;

                settled = true;
                timer && clearInterval(timer);
                checkInterval && clearInterval(checkInterval);

                try {
                    Swal.fire({
                        icon: 'success',
                        title: 'ชำระเงินสำเร็จ',
                        text: 'ระบบได้บันทึกข้อมูลเรียบร้อยแล้ว',
                        // confirmButtonText: 'ตกลง',
                        customClass: {
                            popup: 'swal-wide',
                            confirmButton: 'btn-bla'// pv-btn-primary
                        }
                    }).then(() => {
                        router.replace('/BACSuccess');
                    });
                } catch (err) {
                    console.error('handlePaidOnce error:', err);
                    Swal.fire({
                        icon: 'error',
                        title: 'เกิดข้อผิดพลาด',
                        text: 'ไม่สามารถบันทึกข้อมูลการชำระเงินได้ กรุณาติดต่อเจ้าหน้าที่',
                        customClass: {
                            popup: 'swal-wide',
                            confirmButton: 'btn-bla'// pv-btn-primary
                        }
                    });
                }
            };

            // เริ่ม session (นับถอยหลัง + polling) สำหรับ ref ที่กำหนด
            const startSession = (ref1, ref2, startRemain) => {
                // ตั้งค่าเริ่มต้นของรอบนี้
                let localRemain = startRemain;
                settled = false;
                showOverlay(false);
                $cd.textContent = fmtMMSS(localRemain);

                // Countdown (ไม่มี initial check)
                timer && clearInterval(timer);
                checkInterval && clearInterval(checkInterval);

                timer = setInterval(async () => {
                    localRemain = Math.max(0, localRemain - 1);
                    $cd.textContent = fmtMMSS(localRemain);

                    if (localRemain === 0) {
                        clearInterval(timer);

                        // เช็คครั้งสุดท้ายก่อนหยุด polling
                        if (!settled) {
                            const rf = await checkPaymentStatus(ref1, ref2, { isFinal: true });
                            if (rf.ok && rf.isSuccess) {
                                handlePaidOnce();
                                return; // จ่ายแล้ว → redirect (ไม่ต้องโชว์ overlay)
                            }
                        }

                        // ยังไม่จ่าย → หยุด polling + โชว์ overlay + bind ปุ่มสร้างใหม่
                        checkInterval && clearInterval(checkInterval);
                        showOverlay(true);
                        bindRegenerate(); // ให้ผู้ใช้กดเพื่อเริ่มรอบใหม่
                    }
                }, 1000);

                // Polling ทุก 10 วิ (ไม่มีการยิงทันที)
                checkInterval && clearInterval(checkInterval);

                let inFlight = false;
                checkInterval = setInterval(async () => {
                    if (settled || inFlight) return;
                    inFlight = true;
                    showChecking(true);
                    const r = await checkPaymentStatus(ref1, ref2);
                    showChecking(false);
                    inFlight = false;
                    if (r.ok && r.isSuccess) handlePaidOnce();
                }, 10000);

            };

            // bind ปุ่ม "สร้าง QR Code ใหม่" (เรียกใช้เมื่อ overlay โชว์)
            const bindRegenerate = () => {
                const $regen = $html.querySelector('#btn-regenerate');
                if (!$regen) return;
                $regen.addEventListener('click', async () => {
                    try {
                        Swal.showLoading();

                        // เคลียร์รอบเดิมก่อน
                        timer && clearInterval(timer);
                        checkInterval && clearInterval(checkInterval);

                        // ขอ QR ใหม่จาก API
                        const next = await fetchPaymentQR();
                        if (!next) return;

                        // อัปเดต UI/ข้อมูล
                        $img.src = next.img;
                        $ref1.textContent = next.ref1 ?? '-';
                        $ref2.textContent = next.ref2 ?? '-';

                        // เริ่มรอบใหม่ด้วย ref ใหม่ (ยังคง: ไม่เช็คตอนเปิด, เช็คทุก 10 วิ, เช็คครั้งสุดท้าย)
                        startSession(next.ref1, next.ref2, next.remainSec || DURATION_SEC);
                    } catch (e) {
                        console.error('regen error:', e);
                        Swal.fire({ icon: 'error', text: 'ไม่สามารถสร้าง QR ใหม่ได้' });
                    } finally {
                        Swal.hideLoading();
                    }
                }, { once: true });
            };

            // เริ่มรอบแรกจากค่าใน DOM (ไม่ยิงเช็คทันที)
            startSession(ref1Val, ref2Val, firstRemain);

        },
        willClose: () => {
            if (timer) clearInterval(timer);
            if (checkInterval) clearInterval(checkInterval);
        }
    });
}